import Image from 'next/image'
import Link from 'next/link'

import { BASE_URL } from '@/shared/lib/const/env'

import cl from './slide-el.module.scss'

type SlideProps = {
	img: string
	imgMobile: string
	link?: string
	name: string
	withoutBaseUrl?: boolean
	width?: number
	height?: number
	lazy?: boolean
}

export const SlideEl = (props: SlideProps) => {
	const { img, imgMobile, link = undefined, name, withoutBaseUrl, width, height, lazy } = props

	const slide = (
		<div className={cl.image}>
			<div className={cl.image__desktop}>
				<Image
					src={`${withoutBaseUrl ? `` : BASE_URL}${img}`}
					alt={name}
					width={width ? width : 1440}
					height={height ? height : 355}
					loading={lazy ? 'lazy' : 'eager'}
				/>
			</div>
			<div className={cl.image__mobile}>
				<Image
					src={`${withoutBaseUrl ? `` : BASE_URL}${imgMobile}`}
					width={width ? width : 1200}
					height={height ? height : 482}
					alt={name}
					loading={lazy ? 'lazy' : 'eager'}
				/>
			</div>
		</div>
	)

	if (!!link)
		return (
			<Link prefetch={false} href={link}>
				{slide}
			</Link>
		)

	return <> {slide} </>
}
